<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="chapter">Contents</h1>
<p class="nonindent" id="p01a"><a class="hlink" href="#/OEBPS/9780062032379_epub_p01_r1.htm">Part One - Prom</a></p>
<p class="indent" id="c01a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c01_r1.htm">One</a></p>
<p class="indent" id="c02a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c02_r1.htm">Two</a></p>
<p class="indent" id="c03a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c03_r1.htm">Three</a></p>
<p class="indent" id="c04a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c04_r1.htm">Four</a></p>
<p class="indent" id="c05a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c05_r1.htm">Five</a><br/><br/></p>
<p class="nonindent" id="p02a"><a class="hlink" href="#/OEBPS/9780062032379_epub_p02_r1.htm">Part Two - Special Care</a></p>
<p class="indent" id="c06a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c06_r1.htm">Six</a></p>
<p class="indent" id="c07a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c07_r1.htm">Seven</a></p>
<p class="indent" id="c08a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c08_r1.htm">Eight</a></p>
<p class="indent" id="c09a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c09_r1.htm">Nine</a></p>
<p class="indent" id="c10a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c10_r1.htm">Ten</a></p>
<p class="indent" id="c11a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c11_r1.htm">Eleven</a></p>
<p class="indent" id="c12a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c12_r1.htm">Twelve</a><br/><br/></p>
<p class="nonindent" id="p03a"><a class="hlink" href="#/OEBPS/9780062032379_epub_p03_r1.htm">Part Three - The Ugly American</a></p>
<p class="indent" id="c13a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c13_r1.htm">Thirteen</a></p>
<p class="indent" id="c14a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c14_r1.htm">Fourteen</a></p>
<p class="indent" id="c15a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c15_r1.htm">Fifteen</a></p>
<p class="indent" id="c16a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c16_r1.htm">Sixteen</a></p>
<p class="indent" id="c17a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c17_r1.htm">Seventeen</a></p>
<p class="indent" id="c18a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c18_r1.htm">Eighteen</a></p>
<p class="indent" id="c19a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c19_r1.htm">Nineteen</a><br/><br/></p>
<p class="nonindent" id="p04a"><a class="hlink" href="#/OEBPS/9780062032379_epub_p04_r1.htm">Part Four - Auld Reekie</a></p>
<p class="indent" id="c20a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c20_r1.htm">Twenty</a></p>
<p class="indent" id="c21a"><a class="hlink" href="#/OEBPS/9780062032379_epub_c21_r1.htm">Twenty-One</a><br/><br/></p>
<p class="nonindent" id="epia"><a class="hlink" href="#/OEBPS/9780062032379_epub_epi_r1.htm">Epilogue</a></p>
<p class="nonindent" id="acka"><a class="hlink" href="#/OEBPS/9780062032379_epub_ack_r1.htm">Acknowledgments</a></p>
<p class="nonindent" id="ataa"><a class="hlink" href="#/OEBPS/9780062032379_epub_ata_r1.htm">About the Author</a></p>
<p class="nonindent" id="fm1a"><a class="hlink" href="#/OEBPS/9780062032379_epub_fm1_r1.htm">Praise for An Innocent, a Broad</a></p>
<p class="nonindent" id="copa"><a class="hlink" href="#/OEBPS/9780062032379_epub_cop_r1.htm">Copyright</a></p>
<p class="nonindent" id="atpa"><a class="hlink" href="#/OEBPS/9780062032379_epub_atp_r1.htm">About the Publisher</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062032379_epub_toc_r1.vue?7fc543a3